import request from "@/utils/httpRequest.js"

/**
 * 加载字段记录
 * @param {} params 
 * @returns 
 */
 export function fetchFieldsRecord(params) {
  return request({
    url: 'form/record/fields',
    method: 'get',
    params
  })
}

export function submitForm(data) {
  return request({
    url: 'form/record/submit',
    method: 'post',
    data
  })
}

